import React, { useState } from "react";
import Sidebar from "../../Component/Sidebar/Sidebar";
import Header from "../../Component/Header/Header";
import Tabs from "./components/Tabs/Tabs";
import OverviewTab from "./components/OverviewTab/OverviewTab";
import ExpensesTab from "./components/ExpensesTab/ExpensesTab";
import RevenueTab from "./components/Revenue/RevenueTab";
import styles from "./Accounting.module.css";
import { OverviewIcon, ExpensesIcon, RevenueIcon, CapitalIcon, SupplierIcon } from "../../Component/Shared/Icon/Icon";
import CapitalTab from "./components/CapitalTab/CapitalTab";
import SupplierTab from "./components/SupplierTab/SupplierTab";
import { Navigate } from "react-router-dom";
import FinancialPasswordModal from "./components/FinancialAccessModal/FinancialPasswordModal";

const TABS = [
  { key: "overview", label: "نظرة عامة", icon: <OverviewIcon /> },
  { key: "expenses", label: "المصروفات", icon: <ExpensesIcon /> },
  { key: "revenue",  label: "الإيرادات",   icon: <RevenueIcon /> },
  { key: "capital",  label: "رأس المال",  icon: <CapitalIcon /> },
   { key: "suppliers", label: "الموردين", icon: <SupplierIcon /> },
];

const Accounting = () => {
  const [activeTab, setActiveTab] = useState("overview");
  const [passwordModalOpen, setPasswordModalOpen] =
  useState(false);

   const financialToken = sessionStorage.getItem(
    "financialAccessToken"
  );

  if (!financialToken) {
    return <Navigate to="/home-page" replace />;
  }



  const renderTab = () => {
    switch (activeTab) {
      case "overview":
        return <OverviewTab />;
      case "expenses":
        return <ExpensesTab />;
      case "revenue":
        return <RevenueTab />;
      case "capital":
        return <CapitalTab />;
      case "suppliers":
        return <SupplierTab />;
      default:
        return null;
    }
  };

  return (
    <div className="apDiv ChatApp">
      <Sidebar />
      <div className="body_container container" dir="rtl">
        <div className="Header">
          <Header />
        </div>

       <div className={styles.pageContent}>
  <Tabs
    tabs={TABS}
    activeTab={activeTab}
    onChange={setActiveTab}
  />

<div className={styles.securityCard}>
  <div className={styles.securityInfo}>
    <div className={styles.securityIcon}>
      <span>🔐</span>
    </div>

    <div>
      <h3>أمان القسم المحاسبي</h3>

      <p>
        يمكنك تغيير كلمة مرور الدخول إلى القسم المحاسبي
        في أي وقت للحفاظ على أمان بياناتك.
      </p>
    </div>
  </div>

  <button
    type="button"
    className={styles.changePasswordButton}
    onClick={() => setPasswordModalOpen(true)}
  >
    <span>تغيير كلمة المرور</span>
    <span className={styles.arrow}>←</span>
  </button>
</div>

  {renderTab()}
</div>

<FinancialPasswordModal
  open={passwordModalOpen}
  onClose={() => setPasswordModalOpen(false)}
/>
      </div>
    </div>
  );
};

export default Accounting;